module.exports = __webpack_public_path__ + "static/media/nar-3.48494134.jpg";